
import './CSS/laRam.scss';
import krf from './Assets/KRF.png';
import krfR2 from './Assets/KRF_R2.png';
import krfJeuCaracteres from './Assets/KRF_R2-JeuDeCaractères.png';
import krfR3 from './Assets/KRF-R3.png';

export default function CaractereEcran()
{
    return (
        <div className='Page'>
            <h1>Envoi d'un caractère à l'écran</h1>

            <p>
                Voici un de nos premier objectif qui va nous obliger à voir ou revoir plusieurs choses.
            </p>

            <p>
                Premièrement notez que je ne parle pas d'affichage.<br/>
                Effectivement, on ne fera jamais réellement d'affichage sur VG5000 puisqu'on ne peut pas envoyer directement un octet ou un pixel à l'écran.
            </p>

            <p>
                Notre écran comme déjà dit est donc une matrice de caractères.<br/>
                On pourra dans cette matrice placer à caractère à une position X,Y et lui donner éventuellement des couleurs et des attributs.
            </p>

            <p>
                Pour ce cours nous utiliserons le Mode 40 colonnes en mode long.<br/>
                La raison est que ce mode est celui qui offre le plus de possibilités.<br/>
                Il nous permettra donc de voir le plus de choses et ainsi d'acquerrir plus de connaissances d'un coup.
            </p>
            <p>
                Cependant prenez bien garde qu'il s'agit ici d'expliquer le concept et qu'au final dès que vous serez dans un autre mode, il y aura des contraintes et/ou d'autres possibilités.
            </p>

            <h2>KRF</h2>

            <p>
                Commencez par couper les interruptions avec un DI si vous ne voulez pas que le System viennent vous embêter.<br/>
                Dans le futur je vous donnerai quelques solutions pour le couper autrement.
                Il faudra dors et déjà se placer dans le bon mode avec les commandes TGS et PAT.<br/>
                Dans l'idéal il faudrait vider l'écran mais c'est moins simple qu'il n'y parait.
            </p>

            <p>
                Afin d'envoyer un caractère à l'écran dans ce mode graphique nous utiliserons la commande KRF(on utilisera d'autres commandes pour les autres modes).
            </p>
            <p>
                <img className="krf" src={krf} alt="krf" />
            </p>

            <p>
                KRF vous permet soit de récupérer les informations d'un caractère déjà à l'écran, soit d'envoyer un caractère.<br/>
                Le bit 0 pourra vous être utile pour envoyer (ou lire) plusieurs caractères à la suite puisqu'il incrémentera la coordonnée X après l'éxecution de la commande.
            </p>

            <p>
                Nous devrons donc bien évidement placer cette valeur (%00000000) dans R0 pour indiquer la commande.
            </p>

            <p>
                Voyons les autres registres utiles.
            </p>

            <h2>R1 - Numéro de caractère</h2>

            <p>
                Ce registre contient (dans le cas d'un caractère standard) l'octet C.<br/>
                Cet octet C, vous le retrouvez dans les tables des caractères. Par exemple dans le jeu G0, ce sont les bits C0 à C7.
            </p>

            <p>
                Attention cependant, pour un caractère redéfini R1 sera un peu plus complexe à définir. Mais ou y reviendront plus tard.
            </p>

            <h2>R2 - Jeu de caractère</h2>

            <p>
                Donner le numéro de caractère c'est bien, mais dire ou on le prend c'est mieux.<br/>
                R2 est là pour cela.
            </p>

            <p>
                <img className="krfr2" src={krfR2} alt="krf r2" />
            </p>

            <p>
                Le bit 7 est très important, c'est lui qui permettra de dire si vous utilisez un jeu de caractères standards ou si vous utilisez des caractères redéfinis.
            </p>

            <p>
                Les bits 4 à 6 donnent le nom du jeu de caractère:
            </p>

            <p>
                <img className="jeuCaractere" src={krfJeuCaracteres} alt="Choix du jeu de caractères." />
            </p>

            <p>
                Comme vous pouvez le voir, nous avons déjà un premier attribut avec le soulignement sur certains jeux de caractères.
            </p>

            <p>
                Les bits 0 à 3 donnent les autres attibuts: <br/>
                <ul>
                <li>L = Doubler la largeur du caractère.</li>
                <li>M = Masquer le caractère.</li>
                <li>H = Doubler la hauteur du caractère.</li>
                <li>i = ne sert à rien, ca n'est pas connecté...</li>
                </ul>
            </p>

            <h2>R3 - Couleurs et attributs</h2>

            <p>Oui... Encore des attibuts !</p>

            <p>
                <img className="krfR3" src={krfR3} alt="KRF r3." />
            </p>

            <p>
                Le schéma parle de lui même, pas grand chose à ajouter.
            </p>

            <h2>R6 et R7 - Les positions</h2>

            <p>
                Il nous reste à parler des registres 6 et 7.<br/>
                Là encore pas grand chose à dire puisqu'il s'agit simplement et respectivement des coordonnées Y et X<br/>
                Pas grand chose ? Eh bien si... Car si cela était si simple ca ne serait pas drôle !
            </p>

            <p>
                Comme tout est plus ou moins mal pensé sur ce VDP, la coordonnée Y n'est pas juste une valeur qui commence à 0 et s'incrémente pour chaque ligne.
            </p>
            <p>
                R6 correspond au numéro de la ligne.<br/>
                J'attire votre attention sur le cas particulier de la ligne 0 qui a un statut spécial et fait objet d'un chapitre spécial.<br/>
                Notez pour celle-ci qu'il est préférable de l'ignorer en temps que ligne.
            </p>
            
            <p>
                Considérez que les lignes commencent au numéro 1 ce qui simplifiera bien des choses à commencer par le calcul du numéro de ligne.
            </p>

            <p>
                En effet, dans R6 vous devrez mettre une valeur qui correspond au numéro de ligne souhaité auquel vous ajouterez 7.<br/>
                Si vous souhaitez la ligne 1 il faudra donc y mettre 8, si vous souhaitez la ligne 2 il faudra y mettre 9…<br/>
                Mais pour la ligne 0 c'est un cas particulier puisqu'il faudrait y mettre 0...<br/>
                Il sera dors et déjà plus simple pour vous d'oublier la ligne 0 et de faire une simple routine ajoutant systématiquement 7 au numéro de ligne voulu.
            </p>

            <h2>Démonstration</h2>

            <p className="code">
                <pre>
                	1|               org     #5000<br/>
                    2|<br/>
		            3|               DI<br/>
                    4|<br/>
		            5|               CALL    setMode<br/>
		            6|               CALL    putCar<br/>
		            7|               RET<br/>
                    8|<br/>
                    9|<br/>
                    10|<br/>
                    11|;***************************************<br/>
                    12|;Changement de mode en 40 colonnes long.<br/>
                    13|;***************************************<br/>
                    14|  setMode<br/>
                    15|              LD      A,#20+1<br/>
                    16|              OUT     (#8F),A         ;R1 select<br/>
                    17|              LD      A,%00000000     ;TGS bit 7 & 6 = 0 pour mode 40 long<br/>
                    18|              OUT     (#CF),A         ;envoi valeur<br/>
                    19|<br/>
                    20|              LD      A,#20+0+8       ;R0+EXE<br/>
                    21|              OUT     (#8F),A<br/>
                    22|              LD      A,%10000001     ;TGS EXE<br/>
                    23|              OUT     (#CF),A<br/>
                    24|<br/>
                    25|              CALL    wait<br/>
                    26|<br/>
                    27|;****************************************<br/>
                    28|<br/>
                    29|              LD      A,#20+1<br/>
                    30|              OUT     (#8F),A         ;R1 select<br/>
                    31|              LD      A,%00111111     ;bit 7 = 0<br/>
                    32|              OUT     (#CF),A<br/>
                    33|<br/>
                    34|              LD      A,#20+0+8       ;R0+exe<br/>
                    35|              OUT     (#8F),A<br/>
                    36|              LD      A,%10000011<br/>
                    37|              OUT     (#CF),A         ;PAT EXE<br/>
                    38|<br/>
                    39|              CALL    wait<br/>
                    40|<br/>
                    41|              RET<br/>
                    42|;*****************************<br/>
                    43|;routine d'attente de l'EF9345<br/>
                    44|;*****************************<br/>
                    45|  wait<br/>
                    46|              LD     A,#20            ;R0<br/>
                    47|              OUT    (#8f),A<br/>
                    48|  isBusy      IN     A,(#CF)<br/>
                    49|              OR     A<br/>
                    50|              JP     M,isBusy<br/>
                    51|              RET<br/>
                    52|<br/>
                    53|;****************************<br/>
                    54|;place un caractère à l'écran<br/>
                    55|;****************************<br/>
                    56|<br/>
                    57|  putCar<br/>
                    58|              LD     A,#20+1          ;R1<br/>
                    59|              OUT    (#8F),A<br/>
                    60|              LD     A,%00000001      ;caractère â<br/>
                    61|              OUT    (#CF),A<br/>
                    62|<br/>
                    63|              LD     A,#20+2          ;R2<br/>
                    64|              OUT    (#8F),A<br/>
                    65|              LD     A,%00000000      ;jeu de caractère G0 et aucun attribut<br/>
                    66|              OUT    (#CF),A<br/>
                    67|<br/>
                    68|              LD     A,#20+3          ;R3<br/>
                    69|              OUT    (#8F),A<br/>
                    70|              LD     A,%01110001      ;ecriture blanche et fond noir<br/>
                    71|              OUT    (#CF),A<br/>
                    72|<br/>
                    73|              LD     A,#20+6          ;R6<br/>
                    74|              OUT    (#8F),A<br/>
                    75|              LD     A,10+7           ;Y=10<br/>
                    76|              OUT    (#CF),A<br/>
                    77|<br/>
                    78|              LD     A,#20+7          ;R7<br/>
                    79|              OUT    (#8F),A<br/>
                    80|              LD     A,10             ;x=10<br/>
                    81|              OUT    (#CF),A<br/>
                    82|<br/>
                    83|              LD     A,#20+8          ;R0+exe<br/>
                    84|              OUT    (#8F),A<br/>
                    85|              LD     A,%00000001      ;KRF<br/>
                    86|              OUT    (#CF),A<br/>
                    87|<br/>
                    88|              CALL   wait<br/>
                    89|<br/>
                    90|              RET<br/>
                </pre>
            </p>

            <p>
                Bravo, vous venez d'envoyer un caractère à l'écran. Et oui, tout ça pour ça...
            </p>
            <p>
                Petite précision : J'ai mis le bit 0 de KRF à 1 pour que le curseur soit sur le caractère suivant.
            </p>

        </div>
    )
}